import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function MoveRightIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M4.75 4.75V19.25M8.75 12H19.25M19.25 12L15.75 8.75M19.25 12L15.75 15.25"
        stroke="#384150"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
